import {
  ModalContextReducer,
  ModalContextState,
  OpenOfferDetailsModalDispatchAction
} from '../../shoplist-app/shopping/types/ShoppingPageType'
import { areAllModalsClosed } from './ModalContext'
import {
  MODAL_OPEN_STATUS,
  MODAL_CLOSED_STATUS,
  MODAL_CONTEXT_OFFER_DETAILS_OPEN_ACTION,
  MODAL_CONTEXT_OFFER_DETAILS_CLOSE_ACTION
} from '../../lib/client-constants'
type OpenOfferDetailsModalAction = (
  prevState: ModalContextState,
  action: OpenOfferDetailsModalDispatchAction
) => ModalContextState
type CloseOfferDetailsModalAction = (
  prevState: ModalContextState
) => ModalContextState

const openOfferDetailsModalAction: OpenOfferDetailsModalAction = (
  prevState,
  action
) => {
  if (areAllModalsClosed(prevState)) {
    if (action.payload.honeyOfferId && action.payload.honeyStoreId) {
      const state = { ...prevState }
      state.offerDetailsModal.status = MODAL_OPEN_STATUS
      state.offerDetailsModal.honeyOfferId = action.payload.honeyOfferId
      state.offerDetailsModal.honeyStoreId = action.payload.honeyStoreId
      return state
    }
  }
  return { ...prevState }
}
const closeOfferDetailsModalAction: CloseOfferDetailsModalAction =
  prevState => {
    if (prevState.offerDetailsModal.status === MODAL_OPEN_STATUS) {
      const state = { ...prevState }
      state.offerDetailsModal.status = MODAL_CLOSED_STATUS
      state.offerDetailsModal.honeyOfferId = null
      state.offerDetailsModal.honeyStoreId = null
      return state
    }
    return { ...prevState }
  }

export const offerDetailsModalReducer: ModalContextReducer = (
  prevState,
  action
) => {
  switch (action.type) {
    case MODAL_CONTEXT_OFFER_DETAILS_OPEN_ACTION:
      return openOfferDetailsModalAction(prevState, action)
    case MODAL_CONTEXT_OFFER_DETAILS_CLOSE_ACTION:
      return closeOfferDetailsModalAction(prevState)
    default:
      return { ...prevState }
  }
}
